import { render } from "./ProgettiDismessi.vue?vue&type=template&id=1062536a&ts=true"
import script from "./ProgettiDismessi.vue?vue&type=script&lang=ts"
export * from "./ProgettiDismessi.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__